const leaveWithoutSaving = (state, action) => ({
  ...state,
  leaveDestinationPath: action.payload.destinationPath,
  editing:
    action.payload.keepEditing !== null
      ? action.payload.keepEditing
      : state.editing,
});

export default leaveWithoutSaving;
